<template>
	<div class="list-view no-sub-header">

		<div class="filters">
			<label>Bay</label>
			<select v-model="filters.product_id" @change="getRangeLanes()">
				<option :value="''">Select...</option>
				<option v-for="rangeProduct in rangeProducts" :value="rangeProduct.product_id">{{ rangeProduct.description }}</option>
			</select>
			<div v-if="view != 'month'">

				<div :class="['button', filters.product_id ? 'neutral' : 'disabled']" @click="toggleGrid()">View as {{ subView == 'grid' ? 'List' : 'Grid' }}</div>

				<div class="divider"></div>
				<button class="button back neutral" @click="view = 'month'">Back to Calendar</button>
			</div>
			<div class="divider"></div>
			<router-link v-if="legacyLink" :to="legacyLink" class="extra-menu-item">Legacy Version</router-link>
		</div>

		<div class="detail">

			<div v-if="view != 'month'" class="calendar-view-header" style="margin: 1em 0;">
				<h3>{{ currentDate.format('MMMM DD, YYYY') }} {{ bayName ? "&rang; " + bayName : '' }}</h3>
			</div>

			<calendar-view
				v-if="view === 'month'"
				:show-date="showDate"
				:items="calenderItems"
				:date-classes="safeDateClasses"
				currentPeriodLabel="•"
				:periodChangedCallback="changeMonth"
				:showTimes=true
				@click-date="showCalendarDateDetail"
				@click-item="showCalendarItemDetail"
				class="range-schedule theme-default holiday-us-traditional holiday-us-official">
				<template #header="{ headerProps }">
					<calendar-view-header
						:header-props="headerProps"
						@input="setShowDate" />
				</template>
			</calendar-view>

			<div v-else-if="subView === 'grid'">
				<div style="width: 100%; overflow-x: scroll;">
					<table class="range-grid" :style="'width: ' + ((rangeLanes.length * 10) + 5) + 'em'">
						<tr>
							<th></th>
							<th v-for="(rangeLane, index) in rangeLanes" class="center">{{ rangeLane.description }}</th>
						</tr>
						<tr v-for="(rangeTime, index) in rangeLaneTimes" :key="'range_time_' + index">
							<td class="range-grid-time">{{ rangeTime.description }}</td>
							<td v-for="(rangeLane, index) in rangeLanes" class="range-grid-cell" :key="'range_lane_' + index">
								<div v-if="isReserved(rangeLane, rangeTime.reservationDate)" class="reserved" :style="'width: 100%; height: calc(' + (rangeTime.cellheight * 2.5) + 'em + ' + (rangeTime.cellheight - 1) + 'px);'" @click="showReservation(isReserved(rangeLane, rangeTime.reservationDate))">
									<i class="fa-solid fa-user"></i><br>
									{{ (isReserved(rangeLane, rangeTime.reservationDate).first_name + ' ' + isReserved(rangeLane, rangeTime.reservationDate).last_name).length > 18 ? (isReserved(rangeLane, rangeTime.reservationDate).first_name + ' ' + isReserved(rangeLane, rangeTime.reservationDate).last_name).substring(0, 18) + '...' : (isReserved(rangeLane, rangeTime.reservationDate).first_name + ' ' + isReserved(rangeLane, rangeTime.reservationDate).last_name) }}
									<div v-if="movingReservation && (isReserved(rangeLane, rangeTime.reservationDate).range_reservation_id != movingReservation || isReserved(rangeLane, rangeTime.reservationDate).shopping_cart_reservation_id != movingReservation)">Moving</div>
								</div>
								<div v-else class="open" @click="doGridClick(rangeLane, rangeTime.reservationDate)"></div>
							</td>
						</tr>
					</table>
				</div>
			</div>

			<div v-else class="range-day-view">
				<div v-if="rangeReserved.length === 0" class="empty-list">No reservations {{ filters.product_id ? 'for ' + bayName : '' }}<br>on this day</div>
				<div v-for="reservation in rangeReserved" class="range-day-item">
					<div>
						<label>Bay</label>
						<div class="range-day-item-info">{{ reservation.bay }}</div>
						<label>Lane</label>
						<div class="range-day-item-info">{{ reservation.lane }}</div>
					</div>
					<div>
						<label>Time</label>
						<div class="range-day-item-info">{{ $moment(reservation.reservation_date).format('h:mm A') }}</div>
						<label>Duration</label>
						<div class="range-day-item-info">{{ reservation.duration }} minutes</div>
					</div>
					<div>
						<label>Customer</label>
						<div class="range-day-item-info">{{ reservation.first_name }} {{ reservation.last_name }}</div>
						<label>Contact</label>
						<div class="range-day-item-info">{{ reservation.phone_number }} <span v-if="reservation.phone_number && reservation.email_address">/</span> {{ reservation.email_address }}</div>
					</div>
				</div>
			</div>
		</div>

		<div v-if="showReservationDetail" class="modal">
			<div class="inner">
				<h2>{{ reservationDetail.range_reservation_id || reservationDetail.shopping_cart_reservation_id ? 'Existing' : 'New' }} Reservation</h2>
				<div v-if="reservationDetail.range_reservation_id || reservationDetail.shopping_cart_reservation_id" class="content">
					<div v-if="reservationDetail.contact_id">
						<div class="three-columns v-spaced">
							<div>
								<label>Bay</label>
								<div>{{ bayName }} {{ laneName }}</div>
							</div>
							<div>
								<label>Start</label>
								<div>{{ $moment(reservationDetail.reservation_date).format('M/D/YYYY h:mm A') }}</div>
							</div>
							<div>
								<label>Duration</label>
								<div>{{ reservationDetail.duration }} minutes</div>
							</div>
						</div>
						<div class="two-columns v-spaced">
							<div>
								<label>Customer</label>
								<div>{{ reservationDetail.first_name }} {{ reservationDetail.last_name }}</div>
							</div>
							<div>
								<label>Contact</label>
								<div>{{ reservationDetail.phone_number }} <span v-if="reservationDetail.phone_number && reservationDetail.email_address">/</span> {{ reservationDetail.email_address }}</div>
							</div>
						</div>
						<div v-if="reservationDetail.address_1" class="v-spaced">
							<label>Address</label>
							<div>{{ reservationDetail.address_1 }}</div>
							<div v-if="reservationDetail.city">
								{{ reservationDetail.city }} {{ reservationDetail.state }} {{ reservationDetail.zip_code }}
							</div>
						</div>
						<div v-if="!confirmCancelReservation && !confirmMoveReservation" class="v-spaced" style="margin-top: 1em;">
							<div class="button neutral small spaced" @click="confirmCancelReservation = true">Cancel This Reservation</div>
							<div class="button neutral small spaced" @click="confirmMoveReservation = true">Move This Reservation</div>
						</div>
						<div v-if="confirmCancelReservation" style="margin-top: 1em;">
							<div v-if="saving" class="message"><i class="fa fa-spinner fa-spin"></i> Cancelling...</div>
							<div v-else>
								<div class="message v-spaced">Are you sure you want to cancel this reservation?</div>
								<div class="button cancel small spaced" @click="confirmCancelReservation = false">No, Don't Cancel</div>
								<div class="button action small spaced" @click="deleteReservation()">Yes, Cancel This Reservation</div>
							</div>
						</div>
						<div v-if="confirmMoveReservation" style="margin-top: 1em;">
							<div class="message v-spaced">Confirm move, then select an empty slot on the grid...</div>
							<div class="button cancel small spaced" @click="confirmMoveReservation = false">Cancel Move</div>
							<div class="button action small spaced" @click="startMove()">Yes, Move This Reservation</div>
						</div>
					</div>
				</div>
				<div v-else class="content">
					<div class="three-columns v-spaced">
						<div>
							<label>Bay</label>
							<div>{{ bayName }}</div>
						</div>
						<div>
							<label>Lane</label>
							<div>{{ laneName }}</div>
						</div>
						<div>
							<label>Start</label>
							<div>{{ $moment(reservationDetail.reservation_date).format('M/D/YYYY h:mm A') }}</div>
						</div>
					</div>

					<div class="two-columns v-spaced">
						<div>
							<label>Search for an existing customer...</label>
							<div class="input-with-control">
								<input type="search" ref="search_term" v-model="customerSearchTerm" placeholder="Search..." @search="searchCustomers()" v-focus>
								<div :class="['button', searching || !customerSearchTerm ? 'disabled' : 'action', 'input-go']" @click="searchCustomers()"><i class="fas fa-search"></i></div>
							</div>
						</div>
						<div>
							<label>Or create a new customer...</label>
							<div class="button neutral small" @click="reservationDetail.contact_id = ''; showAddCustomer = true">Create New Customer</div>
						</div>
					</div>
					<div v-if="searching" class="message"><i class="fa fa-spinner fa-spin"></i> Searching...</div>
					<div v-if="searchMessage" class="message">{{ searchMessage }}</div>
					<ul v-if="customerList.length > 1" class="clickable-list">
						<li v-for="(customer, index) in customerList" class="clickable-list-item" @click="setNewReservationCustomer(customer)">
							{{ customer.full_name }}<br>
							{{ customer.address_1 }}<br>
							{{ customer.city }} {{ customer.state }} {{ customer.zip_code }}
						</li>
					</ul>
					<div v-if="showAddCustomer" class="two-columns">
						<div>
							<label>First Name</label>
							<input type="text" v-model="reservationDetail.first_name">
						</div>
						<div>
							<label>Last Name</label>
							<input type="text" v-model="reservationDetail.last_name">
						</div>
						<div>
							<label>Email Address</label>
							<input type="text" v-model="reservationDetail.email_address">
						</div>
						<div>
							<label>Phone Number</label>
							<input type="text" v-model="reservationDetail.phone_number">
						</div>
					</div>
					<div v-else-if="reservationDetail.contact_id" class="two-columns v-spaced">
						<div>
							<label>Customer</label>
							<div>{{ reservationDetail.first_name }} {{ reservationDetail.last_name }}</div>
						</div>
						<div>
							<label>Contact</label>
							<div>{{ reservationDetail.phone_number }} <span v-if="reservationDetail.phone_number && reservationDetail.email_address">/</span> {{ reservationDetail.email_address }}</div>
						</div>
					</div>
				</div>
				<div class="controls">
					<div class="button cancel spaced" @click="cancelReservationDetail()">Cancel</div>
					<div v-if="!reservationDetail.range_reservation_id" :class="['button', canSaveReservation ? 'action' : 'disabled', 'spaced']" @click="saveReservation()">Save Reservation</div>
				</div>
			</div>
		</div>

		<message-modal v-if="message" :message="message" :loading="saving" :errorStatus="messageStatus" :timeout="messageTimeout" @dismiss="message = ''" />

	</div>
</template>

<script>
import 'vue-simple-calendar/static/css/default.css'
import CalendarView from "vue-simple-calendar/src/components/CalendarView.vue"
import CalendarViewHeader from "vue-simple-calendar/src/components/CalendarViewHeader.vue"

export default {
	name: 'range-schedule',
	props: ['product_id'],
	components: {
		'calendar-view': CalendarView,
		'calendar-view-header': CalendarViewHeader
	},
	data() {
		return {
			loading: false,
			message: '',
			messageStatus: '',
			messageTimeout: 0,
			saving: false,
			view: 'month',
			subView: '',
			filters: {
				search_term: '',
				product_id: ''
			},
			showDate: new Date(),
			reservations: [],
			today: this.$moment().format('YYYY-MM-DD'),
			// currentDisplayMonth: this.$moment().startOf("month").format('YYYY-MM-DD'),
			currentDisplayMonth: this.$moment().startOf("month"),
			currentDate: this.$moment(),
			rangeProducts: [],
			rangeLanes: [],
			rangeLaneTimes: [],
			productId: null,
			rangeBay: {},
			rangeReserved: [],
			rangeInCart: [],
			showReservationDetail: false,
			showAddCustomer: false,
			customerSearchTerm: '',
			customerList: [],
			searching: false,
			searchMessage: '',
			reservationDetail: {},
			confirmCancelReservation: false,
			confirmMoveReservation: false,
			movingReservation: false,
			legacyLink: '/legacy/rangeschedulemaintenance.php'
		}
	},
	mounted() {
		this.getReservationsThisMonth()
		this.getRangeProducts()
	},
	watch: {
		view() {
			this.movingReservation = false
			this.showReservationDetail = false
			this.confirmCancelReservation = false
			this.reservationDetail = {}
			if (this.view === 'day') {
				this.getRangeReservations()
			}
		}
	},
	computed: {
		calenderItems() {
			const calendarItems = []
			for (const day in this.reservations) {
				// const date = this.currentDisplayMonth.date(day).format('YYYY-MM-DD')
				const date = this.currentDisplayMonth.clone().date(day).format('YYYY-MM-DD')
				calendarItems.push({
					startDate: date,
					title: this.reservations[day] + ' Reservation' + (this.reservations[day] > 1 ? 's' : ''),
				})
			}
			return calendarItems
		},
		bayName() {
			return this.rangeProducts.find(product => product.product_id == this.filters.product_id)?.description
		},
		laneName() {
			return this.rangeLanes.find(lane => lane.range_lane_id == this.reservationDetail.range_lane_id)?.description
		},
		canSaveReservation() {
			return this.reservationDetail.first_name && this.reservationDetail.last_name && this.reservationDetail.product_id && this.reservationDetail.range_lane_id && this.reservationDetail.reservation_date
		}, 
		safeDateClasses() {
			const out = {}

			const start = this.currentDisplayMonth.clone().startOf('month').startOf('week')
			const end = this.currentDisplayMonth.clone().endOf('month').endOf('week')

			const cur = start.clone()
			while (cur.isSameOrBefore(end, 'day')) {
				out[cur.format('YYYY-MM-DD')] = []
				cur.add(1, 'day')
			}
			return out
		}
	},
	methods: {
		getReservationsThisMonth() {
			if (this.loading) { return }
			this.loading = true
			const month_start_date = this.currentDisplayMonth.clone().startOf("month").format('YYYY-MM-DD')
			const month_end_date = this.currentDisplayMonth.clone().endOf("month").format('YYYY-MM-DD')
			const data = {
				month_start_date,
				month_end_date,
				search_term: this.filters.search_term,
				product_id: this.filters.product_id
			}
			this.apiCall({ destination: 'get_reservations_this_month', data }).then(obj => {
				this.loading = false
				this.reservations = obj.reservations
			})
		},
		changeMonth(event) {
			this.currentDisplayMonth = this.$moment(event.periodStart)
			this.getReservationsThisMonth()
		},
		clearFilters() {
			this.filters = {
				search_term: '',
				product_id: '',
			}
			this.getReservationsThisMonth()
		},
		showCalendarDateDetail(event) {
			let date = this.$moment(event)
			this.view = 'day'
			this.currentDate = date
		},
		showCalendarItemDetail(event) {
			let date = this.$moment(event.startDate)
			this.view = 'day'
			this.currentDate = date
		},
		setShowDate(d) {
			this.showDate = d;
		},
		getRangeProducts() {
			this.apiCall({ destination: 'get_range_products' }).then(obj => {
				this.rangeProducts = obj.range_products
				if (!this.productId) {
					this.productId = this.rangeProducts[0].product_id
				}
			})
		},
		getRangeLanes() {
			if (this.loading) { return }
			this.loading = true
			this.rangeLaneTimes = []
			this.apiCall({ destination: 'get_range_lanes', data: { product_id: this.filters.product_id, reservation_date: this.currentDate.format('YYYY-MM-DD'), include_reservations: true }}).then(obj => {
				this.loading = false
				if (obj.range_lanes && obj.range_lanes.length > 0 && obj.range_lanes[0].range_lanes) {
					this.rangeLanes = obj.range_lanes[0].range_lanes
					let useDate = this.currentDate.format('YYYY-MM-DD')
					let duration = 15 // obj.range_lanes[0].duration
					let bayStartHour = obj.range_lanes[0].start_hour
					let bayEndHour = obj.range_lanes[0].end_hour
					let rangeTimes = []
					let time = this.$moment(`${useDate} ${bayStartHour}`, 'YYYY-MM-DD HHmm')
					let endHour = this.$moment(`${useDate} ${bayEndHour}`, 'YYYY-MM-DD HHmm')
					while(time.isSameOrBefore(endHour)) {
						rangeTimes.push({
							description: time.format('h:mm A'),
							reservationDate: time.format('YYYY-MM-DD HH:mm:ss'),
							expired: time.isBefore(this.$moment()),
							cellheight: obj.range_lanes[0].duration / 15,
						})
						time.add(duration, 'minutes')
					}
					this.rangeLaneTimes = rangeTimes
					switch (this.view) {
						case 'month':
							this.getReservationsThisMonth()
							break
						case 'day':
							this.getRangeReservations()
							break
					}
				}
			})
		},
		getRangeReservations() {
			if (this.loading) { return }
			this.loading = true
			this.apiCall({ destination: 'get_range_reservations', data: { product_id: this.filters.product_id, reservation_date: this.currentDate.format('YYYY-MM-DD') }}).then(obj => {
				this.loading = false
				this.rangeReserved = obj.range_reserved
				if (this.filters.product_id) {
					this.subView = 'grid'
				} else {
					this.subView = 'list'
				}
			})
		},
		toggleGrid() {
			if (this.filters.product_id ) {
				this.subView = this.subView == 'grid' ? 'list' : 'grid'
			}
		},
		isReserved(rangeLane, reservationDate) {
			return this.rangeReserved.find(reservation => {
				return reservation.range_lane_id == rangeLane.range_lane_id && reservation.reservation_date == reservationDate
			})
		},
		doGridClick(rangeLane, reservationDate) {
			if (this.movingReservation) {
				if (this.saving) { return }
				if (this.isReserved(rangeLane, reservationDate)) {
					this.message = 'This time slot is already reserved!'
					return
				}
				this.reservationDetail.range_lane_id = rangeLane.range_lane_id
				this.reservationDetail.reservation_date = reservationDate
				this.message = 'Moving reservation...'
				let postObject = {
					moving_reservation_id: this.movingReservation,
					reservation_date: reservationDate,
					range_lane_id: rangeLane.range_lane_id,
					range_reservation_id: this.reservationDetail.range_reservation_id,
					shopping_cart_reservation_id: this.reservationDetail.shopping_cart_reservation_id
				}
				this.saving = true
				this.apiCall({ destination: 'move_item_range_reservation', data: postObject }).then(obj => {
					this.saving = false
					this.message = 'Reservation moved!'
					this.messageStatus = 'success'
					this.messageTimeout = 2000
					this.cancelReservationDetail()
					this.getRangeReservations()
				})
			} else {
				if (this.isReserved(rangeLane, reservationDate)) {
					this.showReservation(this.isReserved(rangeLane, reservationDate))
					return
				}
				this.reservationDetail = {
					product_id: this.filters.product_id,
					range_lane_id: rangeLane.range_lane_id,
					reservation_date: reservationDate,
					duration: 15,
					contact_id: '',
					first_name: '',
					last_name: '',
					email_address: '',
					phone_number: ''
				}
				this.showReservationDetail = true
			}
		},
		showReservation(reservation) {
			if (this.movingReservation) { return }
			this.reservationDetail = reservation
			this.showReservationDetail = true
		},
		cancelReservationDetail() {
			this.movingReservation = false
			this.showReservationDetail = false
			this.confirmCancelReservation = false
			this.confirmMoveReservation = false
			this.reservationDetail = {}
			this.customerSearchTerm = ''
			this.customerList = []
			this.showAddCustomer = false
			this.searchMessage = ''
		},
		searchCustomers() {
			if (this.searching || !this.customerSearchTerm) { return }
			this.showAddCustomer = false
			this.reservationDetail.contact_id = ''			
			this.reservationDetail.first_name = ''
			this.reservationDetail.last_name = ''
			this.reservationDetail.email_address = ''
			this.reservationDetail.phone_number = ''
			this.searching = true
			this.customerList = []
			this.searchMessage = 'Searching...'
			this.apiCall({ destination: 'get_list_contacts', data: { search_term: this.customerSearchTerm } }).then(obj => {
				this.searching = false
				if (obj.list.length == 1) {
					this.searchMessage = ''
					this.setNewReservationCustomer(obj.list[0])
				} else if (obj.list.length > 1) {
					this.customerList = obj.list
					this.searchMessage = ''
				} else {
					this.searchMessage = 'No matching customers found!'
				}
			}).catch(err => {
				console.log(err)
			})			
		},
		setNewReservationCustomer(customer) {
			this.customerSearchTerm = ''
			this.customerList = []
			this.reservationDetail.contact_id = customer.contact_id
			this.reservationDetail.first_name = customer.first_name
			this.reservationDetail.last_name = customer.last_name
			this.reservationDetail.email_address = customer.email_address
			this.reservationDetail.phone_number = customer.phone_number
		},
		deleteReservation() {
			if (this.saving) { return }
			this.saving = true
			this.message = 'Cancelling reservation...'
			this.apiCall({ destination: 'delete_item_range_reservation', data: { range_reservation_id: this.reservationDetail.range_reservation_id, shopping_cart_reservation_id: this.reservationDetail.shopping_cart_reservation_id } }).then(obj => {
				this.cancelReservationDetail()
				this.saving = false
				this.message = 'Reservation canceled'
				this.messageStatus = 'success'
				this.messageTimeout = 2000
				this.getRangeReservations()
			})
		},
		startMove() {
			this.movingReservation = this.reservationDetail.range_reservation_id || this.reservationDetail.shopping_cart_reservation_id
			this.showReservationDetail = false
		},
		saveReservation() {
			if (this.saving || !this.canSaveReservation) { return }
			this.saving = true
			this.message = 'Saving reservation...'
			this.apiCall({ destination: 'save_item_new_reservation', data: this.reservationDetail }).then(obj => {
				this.cancelReservationDetail()
				this.saving = false
				this.messageStatus = obj.status
				if (obj.status == 'success') {
					this.message = 'Reservation saved!'
					this.messageTimeout = 2000
					this.getRangeReservations()
				} else {
					this.message = 'Error saving reservation: ' + obj.message
				}
			})
		}
	}
}
</script>

<style lang="scss">

.range-day-item {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	border-top: 1px dotted #ccc;
	.range-day-item-info {
		margin: 0 0 0.5em 0;
	}
}

// NOTE: we can style elements inside a component IF scss is NOT scoped
.theme-default .cv-header .periodLabel {
	display: block;
	text-align: right;
	font-size: 1.75em;
}

.cv-weeks {
	// This is necessary since the filter sidebar had a specific height to cause it to fill the screen
	// but that also makes the calendar grow and so the weeks are to tall.
	flex-grow: initial;
}

.cv-item {
	padding: 1em;
}
.cv-week {
	min-height: 7em;
}
.cv-day {
	height: 7em;
}

.range-grid {
	border-collapse: collapse;
	th {
		background-color: #efefef;
		padding: 0.25em 0.5em;
		border-right: 1px solid #ccc;
	}
	td {
		padding: 0.25em 0.5em;
		border-right: 1px solid #ccc;
	}
	.range-grid-time {
		width: 5em;
		height: 2em;
		background-color: #efefef;
		font-weight: bold;
		text-align: right;
		border-bottom: 1px solid #ccc;
	}
	.range-grid-cell {
		position: relative;
		width: 10em;
		height: 2em;
		border-bottom: 1px solid #ccc;
		text-align: center;
		cursor: pointer;
	}
	.open {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: #fff;
	}
	.reserved {
		z-index: 1000;
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		background-color: #e4e4e4;
		color: #000;
		text-align: center;
		padding: 0.5em 0;
		
	}
}

</style>